import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';
import ProgressiveImg from '../components/ProgressiveImg';
import Figure from '../components/Figure';

export default function Joypad() {
  const meta = projectMeta.joypad;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>Joypad began as a weekend hack to turn a smartphone into a game controller. The app connected to a secondary device over Bluetooth or Wifi and allowed users to control different games and emulators. We released the iOS app in 2011 and quickly gained traction with gamers and press like Wired Magazine, Techcrunch and Reddit. Customers started requesting more controllers and support for other emulators. My co‑founder and I eventually founded Joypad, Inc. and released the Joypad SDK. Over the next couple years through sales, developer outreach, and PR initiatives, we integrated the Joypad SDK into more than 100 games across desktop and iOS.</p>

      <div className="media-gallery">

        <Figure caption="NES controller">
          <ProgressiveImg
            src={toCdn('/images/projects/joypad/joypad_1.webp')}
            alt="NES controller"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Retro skins">
          <ProgressiveImg
            src={toCdn('/images/projects/joypad/joypad_2.webp')}
            alt="Retro skins"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Icons">
          <ProgressiveImg
            src={toCdn('/images/projects/joypad/joypad_3.webp')}
            alt="Icons"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Joypad demo video">
          <div className="video-mask">
            <video
              src={toCdn('/images/projects/joypad/joypad.mp4')}
              poster={toCdn('/images/projects/joypad/joypad_poster.webp')}
              aria-label="Joypad demo video"
              className="gallery-item"
              loading="lazy"
              controls
            />
          </div>
        </Figure>
      </div>
    </ProjectDetail>
  );
}
